import React, { useContext, useState } from 'react';
import _ from 'lodash'; // eslint-disable-line
import { shape } from 'prop-types';
import classNames from 'classnames';

import { Button } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { ReservationContext } from '../../context/reservation-context';
import { StoreHours } from '../store-hours/store-hours';
import { AvailabilityList } from '../availability-list/availability-list';
import { StoreDetails } from '../store-details/store-details';
import { AvailabilityTag } from '../availability-tag/availability-tag';
import { NOT_AVAILABLE_FOR_SELECTED_DATE_AT_STORE } from '../../constants/messages';

import './store-card.scss';

export const StoreCard = ({ store }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const [selectedButton, setSelectedButton] = useState(`${store.storeId}-0`);

  const [reservationState, dispatch] = useContext(ReservationContext);
  const { selectedStore } = reservationState;

  const {
    name,
    storeId,
    availableHours
  } = store;

  const isSelected = selectedStore?.storeId === storeId.toString();
  const cursorClass = classNames('location-item',
    { selected: isSelected, unavailable: !availableHours?.length > 0 }
  );

  const handleClick = () => {
    const [, index] = selectedButton.split('-');
    const availabilitySlot = availableHours[index];

    if (availableHours?.length > 0) {
      dispatch(
        {
          type: 'SET_RESERVATION_STORE',
          payload: store
        }
      );

      dispatch(
        {
          type: 'SET_ACTIVE_SECTION',
          payload: 'ReservationSummary'
        }
      );

      dispatch(
        {
          type: 'SET_AVAILABILITY_OPTION',
          payload: availabilitySlot
        }
      );
    }

  };

  return (
    <div
      className={cursorClass}
      id={`item-${storeId}`}
      aria-label={name}
      data-testid={`store-card-${storeId}`}
    >
      <div className="content-row">
        <div className="left-column">
          <StoreDetails store={store} />
          {isMobile && (
            <StoreHours store={store} padding="small" />
          )}
        </div>
        <div className="right-column">
          <AvailabilityTag store={store} />
          {!isMobile && (
            <StoreHours store={store} />
          )}
        </div>
      </div>
      <hr />
      <div className="content-row">
        {availableHours?.length > 0 && !_.isEmpty(availableHours) ? (
          <AvailabilityList
            title="Available"
            store={store}
            availableHours={availableHours}
            selectedButton={selectedButton}
            setSelectedButton={setSelectedButton}
          />
        ) : (
          <div className="unavailable-message">
            {NOT_AVAILABLE_FOR_SELECTED_DATE_AT_STORE}
          </div>
        )}
      </div>
      <div className="content-row">
        <Button data-testid={`${storeId}-button`} disabled={!availableHours?.length > 0} onClick={handleClick} outline>
          Select This Store
        </Button>
      </div>
    </div>
  );
};

StoreCard.propTypes = {
  store: shape({}).isRequired
};
